webpackJsonp_books(["ridi.pc"],{

/***/ "+cOzymuX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ridi = __webpack_require__("635k8xVw");

var _ridi2 = _interopRequireDefault(_ridi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

$(function () {
  var rollingNotice = function rollingNotice() {
    var aniDuration = 3000;
    var aniStatus = {
      ready: 'ani-ready',
      play: 'ani-play'
    };
    var $noticeItems = $('.jsNoticeItem');
    var itemsCount = $noticeItems.length;
    var rolling = function rolling(index) {
      $noticeItems.eq(index).addClass(aniStatus.play);
      setTimeout(function () {
        $noticeItems.eq(index).removeClass(aniStatus.play);
        rolling(index + 1 === itemsCount ? 0 : index + 1);
      }, aniDuration);
    };
    if (itemsCount > 1) {
      $noticeItems.addClass(aniStatus.ready).css('animation-duration', aniDuration + 'ms');
      rolling(0);
    }
  };

  // 상단에 선언된 기능들 호출부.
  _ridi2.default.init();
  rollingNotice();
});

/***/ }),

/***/ "3n2bRMES":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _search = __webpack_require__("6x2ehLnI");

var _search2 = _interopRequireDefault(_search);

var _search3 = __webpack_require__("kCOPoScg");

var _search4 = _interopRequireDefault(_search3);

var _search5 = __webpack_require__("mc2RRXzy");

var _search6 = _interopRequireDefault(_search5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

$(function () {
  var $searchInput = $('#book_search_input').eq(0);
  var $searchHistoryWrap = $('.js_search_history_wrap').eq(0);
  var updateViewCallback = function updateViewCallback(isEmpty) {
    $searchHistoryWrap.toggleClass('history_empty', isEmpty);
  };

  var searchHistory = _search2.default.isEnabled() ? new _search2.default({
    $wrapper: $searchHistoryWrap,
    $list: $('#search_history'),
    $template: $('.js_search_history_tmpl').removeClass('js_search_history_tmpl').remove(),
    $btnClearAll: $('.js_btn_clear_history'),
    $btnTurnOffHistory: $('.js_btn_turn_off_history'),
    $btnTurnOnHistory: $('.js_btn_turn_on_history'),
    updateViewCallback: updateViewCallback
  }, 5) : null;

  var instantSearch = new _search4.default($('#book_search_result'), searchHistory);

  var searchForm = new _search6.default({
    $wrapper: $('.js_search_wrap'),
    $form: $('#search_form'),
    $input: $searchInput,
    $btnResetInput: $('.js_btn_reset_search_input'),
    instantSearch: instantSearch,
    searchHistory: searchHistory
  });
});

/***/ }),

/***/ "gxtk3zvz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _spin = __webpack_require__("oOt8tipF");

var _spin2 = _interopRequireDefault(_spin);

var _gnb = __webpack_require__("sRVytDab");

var _gnb2 = _interopRequireDefault(_gnb);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _gnb2.default)().then(function (GNB) {
  $(function () {
    try {
      GNB.data = Ridi.globals;
    } catch (err) {
      GNB.data = {};
    }

    var clickEvent = GNB.data.isPc ? 'click' : 'touchstart';

    /**
     * 첫 mouseover 시에 ajax요청
     */
    $('.menu_user').one('touchstart click mouseover', function () {
      GNB.refreshMyRidiLayer();
    });

    $('.menu_cart').one('touchstart click mouseover', function () {
      GNB.refreshCartLayer();
    });

    if (GNB.data.isPc) {
      $('html').click(function () {
        $('#all_menu').fadeOut('fast');
      });

      var $defaultActiveGeneralMenu = $('.js_general_menu_wrapper.active');
      $('.js_general_menu_wrapper').hover(function () {
        $defaultActiveGeneralMenu.removeClass('active');
      }, function () {
        $defaultActiveGeneralMenu.addClass('active');
      });

      $('.menu_user').hover(function () {
        $('#divMyMenuLayer').css('display', 'block');
      }, function () {
        $('#divMyMenuLayer').css('display', 'none');
        $('#browser_ie8 #divMyMenuLayer').css('display', 'none');
      });

      $('.menu_cart').hover(function () {
        $('#cartMenuPopup').css('display', 'block');
      }, function () {
        $('#cartMenuPopup').css('display', 'none');
      });
    } else {
      var $noti = $('.menu_noti .GNB_popup');
      var $myridi = $('.menu_user .GNB_popup');
      var $cart = $('.menu_cart .GNB_popup');
      var popups = [$noti, $myridi, $cart];
      var toggle = function toggle($popup) {
        for (var i = 0; i < popups.length; ++i) {
          if (popups[i] === $popup) {
            $popup.toggle();
          } else {
            popups[i].hide();
          }
        }
      };

      $('html').on(clickEvent, function () {
        for (var i = 0; i < popups.length; ++i) {
          popups[i].hide();
        }

        $('#all_menu').fadeOut();
      });

      var _fnStopPropagation = function _fnStopPropagation(e) {
        e.stopPropagation();
      };

      for (var i = 0; i < popups.length; ++i) {
        popups[i].on(clickEvent, _fnStopPropagation);
      }

      // gnb 알림센터, 마이리디, 카트, 위시리스트 페이지 이동하지 않도록 처리!
      $('#gnb_noti_link, #gnb_myridi_link, #gnb_cart_link').attr('href', '#');

      $('#gnb_myridi_link').on(clickEvent, function (e) {
        e.stopPropagation();
        toggle($myridi);
      });

      $('#gnb_cart_link').on(clickEvent, function (e) {
        e.stopPropagation();
        toggle($cart);
      });

      $('.js_general_menu_title').on(clickEvent, function (e) {
        $('.js_general_menu_wrapper.active').removeClass('active');
        $(this).closest('.js_general_menu_wrapper').addClass('active');
        e.preventDefault();
      });
    }
    /**
     * 전체분야 메뉴 제어
     */
    $('#show_all_menu_btn').on(clickEvent, function (e) {
      $('#all_menu').fadeIn('fast');
      e.stopPropagation();
    });

    $('#hide_all_menu_btn').on(clickEvent, function (e) {
      $('#all_menu').fadeOut('fast');
      e.stopPropagation();
    });

    $('.all_menu_wrapper').on(clickEvent, function (e) {
      e.stopPropagation();
    });
  }); // end of document.ready
});

/***/ }),

/***/ "ridi.pc":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("3n2bRMES");
__webpack_require__("gxtk3zvz");
module.exports = __webpack_require__("+cOzymuX");


/***/ })

},["ridi.pc"]);


// WEBPACK FOOTER //
// ridi.pc.min.js